import { WifiOff } from "lucide-react";
import { useNetworkStatus } from "@/hooks/useNetworkStatus";

/**
 * Sticky banner shown when the user goes offline.
 * Auto-disappears when back online.
 */
export default function OfflineBanner() {
  const isOnline = useNetworkStatus();

  if (isOnline) return null;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-50 bg-yellow-500 text-yellow-950 px-4 py-2 text-center text-sm font-medium flex items-center justify-center gap-2"
      role="alert"
    >
      <WifiOff className="h-4 w-4" />
      Нет интернет-соединения. Некоторые функции могут быть недоступны.
    </div>
  );
}
